var dropdownGroup = 'fx_2d2fb1e5_pal1wu0';

export { dropdownGroup };
//# sourceMappingURL=group.vanilla.mjs.map
